import React, { useContext, useEffect, useState } from "react";
import { InputAuto } from "../../../../controls";
import { CartContext } from "../POS";
import { Dialog } from "../../../../layout";
import AddEditCstmr from "../../../Customer/CustomerForm/AddEditCstmr";
import { action, API, controller } from "../../../../api/api";
import { AppContext } from "App";

const SelectCustomer = ({
  size = "small",
  placeholder = "Add Customer",
  setCustomerId,
}) => {
  const { access } = useContext(AppContext);
  const { setCartData, cartData } = useContext(CartContext);
  const [cstmrs, setCstmrs] = useState([]);
  const [newAddingValue, setNewAddingValue] = useState("");
  const [showCstmrForm, setShowCstmrForm] = useState(false);

  useEffect(() => {
    API(controller.Customer + action.GetAllByOrg).get((res) => {
      res &&
        res.status === 200 &&
        setCstmrs([
          ...res.result.map((j) => ({
            ...j,
            label: `${j.firstName + " " + j.lastName} ${
              j.CstmrGroup ? " | " + j.CstmrGroup.name : ""
            }`,
            subtitle: `${j.cstmrCode} ${j.phone && " | " + j.phone}`,
          })),
        ]);
    });

    return () => {};
  }, []);

  const handleCustomer = (e) => {
    var cstmrId = e.target.value;
    setCartData((j) => ({ ...j, customerId: cstmrId }));
    setCustomerId && setCustomerId(cstmrId);
  };

  const handleAddNewCstmr = (val) => {
    setNewAddingValue(val);
    setShowCstmrForm(!showCstmrForm);
  };

  const handleNewCstmr = (val) => {
    if (val) {
      setCstmrs([
        {
          ...val,
          label: `${val.firstName + " " + val.lastName} ${
            val.CstmrGroup ? " | " + val.CstmrGroup.name : ""
          }`,
          subtitle: `${val.cstmrCode} ${val.phone && +" | " + val.phone}`,
        },
        ...cstmrs,
      ]);
      setCartData((j) => ({ ...j, customerId: val.id }));
      setCustomerId && setCustomerId(val.id);
      setNewAddingValue("");
    }
  };

  return (
    <>
      <InputAuto
        placeholder={placeholder}
        value={cartData.customerId}
        onChange={handleCustomer}
        options={cstmrs}
        fullWidth
        enableAddBtn={access?.pos?.createCustomer}
        handleAdd={handleAddNewCstmr}
        size={size}
      />

      {/* Add new customer */}
      {showCstmrForm && (
        <Dialog show={showCstmrForm} onClose={false} maxWidth="md">
          <AddEditCstmr
            {...{
              setShowForm: setShowCstmrForm,
              openFromOtherSide: true,
              customerName: newAddingValue,
              handleResult: handleNewCstmr,
            }}
          />
        </Dialog>
      )}
    </>
  );
};

export default SelectCustomer;
